import React, { useEffect, useState } from 'react';
import { onDegraded } from '../lib/apiClient';
import './DegradedBanner.css';

/**
 * When the API answers with less than it should, say so.
 *
 * Several endpoints return an empty list rather than an error when a query
 * cannot run, so that a half-migrated database renders a page instead of a
 * stack trace. That is still what happens - but the response now carries a
 * header explaining itself, and this is where it surfaces. Without it the soft
 * behaviour is indistinguishable from "there is genuinely nothing here", which
 * has cost several rounds of guessing.
 *
 * Shown once per distinct reason, dismissible, and never blocking.
 */
export default function DegradedBanner() {
  const [reasons, setReasons] = useState([]);

  useEffect(() => onDegraded((reason) => {
    setReasons((current) => (current.includes(reason) ? current : [...current, reason]));
  }), []);

  if (reasons.length === 0) return null;

  return (
    <div className="degraded-banner" role="status" aria-live="polite">
      <div className="degraded-body">
        <strong>Some data could not be loaded.</strong>
        <ul>
          {reasons.map((r) => <li key={r}>{r}</li>)}
        </ul>
        <p className="degraded-note">
          What you can see is real; something the page asked for is missing. This
          usually means a migration has not been applied.
        </p>
      </div>
      <button
        type="button"
        className="degraded-close"
        onClick={() => setReasons([])}
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  );
}
